<mat-card appearance="outlined" [style.background-color]="backgroundColor">
  <ng-container *ngIf="isUserLogged">
    <mat-button-toggle-group
      class="public-mode-toggle"
      *appIfCommandAvailable="'public_simulation_toggle'"
      [value]="isPublic"
      (change)="togglePublic($event)"
      [disabled]="isDisabled || inChangeState"
    >
      <mat-button-toggle [value]="true">
        <mat-icon *ngIf="isPublic">public</mat-icon>
        Public</mat-button-toggle
      >
      <mat-button-toggle [value]="false">
        <mat-icon *ngIf="!isPublic">public_off</mat-icon>
        Private
      </mat-button-toggle>
    </mat-button-toggle-group>
  </ng-container>
  <ng-container *ngIf="isPublic; else notPublic">
    <div class="expiration-info-action">
      <mat-card-actions>
        <ng-container *ngIf="isUserLogged">
          <div
            class="expiration-selector"
            *appIfCommandAvailable="'public_simulation_toggle'"
          >
            <mat-card-title>Expiration:</mat-card-title>

            <mat-button-toggle-group
              class="expiration-length-selector"
              [value]="currentShareLength"
              (change)="setExpiration($event.value)"
              [disabled]="isDisabled || inChangeState"
            >
              <mat-button-toggle [value]="SHARE_LENGTH.DAY">
                1 Day
              </mat-button-toggle>
              <mat-button-toggle [value]="SHARE_LENGTH.WEEK">
                1 Week
              </mat-button-toggle>
              <mat-button-toggle [value]="SHARE_LENGTH.TWOWEEKS">
                2 Weeks
              </mat-button-toggle>
              <mat-button-toggle [value]="SHARE_LENGTH.MONTH">
                1 Month
              </mat-button-toggle>
              <mat-button-toggle [value]="SHARE_LENGTH.THREEMONTHS">
                3 Months
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </ng-container>
        <mat-card-title *ngIf="!isUserLogged">Public simulation</mat-card-title>
        <mat-card-subtitle style="font-size: 14px"
          >Anyone with a link can view this {{ contentType }}</mat-card-subtitle
        >
      </mat-card-actions>
      <div class="expiration-eta">
        <span> Expires in {{ expirationDisplay || 'N/A' }} </span>
      </div>
    </div>
  </ng-container>

  <ng-template #notPublic>
    <mat-card-header style="justify-content: flex-end">
      <mat-card-subtitle>
        Only organization members can view this {{ contentType }}.
      </mat-card-subtitle>
    </mat-card-header>
  </ng-template>
</mat-card>
